import { PLAN_FEATURES_DEFAULT_VALUES, PlanFeatureTypes } from "shared/datamodel/schemas";
import * as Sentry from "@sentry/react";
import { useAtomValue } from "jotai";
import { userPlanFeaturesAtom } from "state-atoms/plan-features-atoms";

// Overloaded function signatures for better type inference
function usePlanFeatureValue<K extends keyof PlanFeatureTypes>(
  feature: K,
  useDefault: false
): PlanFeatureTypes[K] | undefined;
function usePlanFeatureValue<K extends keyof PlanFeatureTypes>(feature: K, useDefault?: true): PlanFeatureTypes[K];
function usePlanFeatureValue<K extends keyof PlanFeatureTypes>(
  feature: K,
  useDefault: boolean = true
): PlanFeatureTypes[K] | undefined {
  const features = useAtomValue(userPlanFeaturesAtom);
  const value = features.get(feature) as PlanFeatureTypes[K] | null;

  if (value === null) {
    Sentry.captureException(`Plan feature value is null`, {
      tags: {
        type: "plan-feature",
        feature,
      },
    });
  }

  return value ?? (useDefault ? PLAN_FEATURES_DEFAULT_VALUES[feature] : undefined);
}

export default usePlanFeatureValue;
